import React from 'react';
import AcceptInvitationForm from '../../Account/LogIn/components/AcceptInvitationForm';
import { useParams } from "react-router-dom";

function AcceptInvitation(props) {
  let { token } = useParams();

  return (
  <div className="account account--photo">
    <div className="account__wrapper">
      <div className="account__card">
        <div className="account__head">
          <h3 className="account__title">
            Welcome to&nbsp;
            <span className="account__logo">
              Lime
              <span className="account__logo-accent">Proxies</span>
            </span>
          </h3>
        </div>
        <AcceptInvitationForm onSubmit token= {token} />
      </div>
    </div>
  </div>
  )
};

export default AcceptInvitation;
